import Config from "../../config/Config";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;
const BaseUrlAttendanceProDev = Config.BaseUrlAttendanceProDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getAttendanceDetail = (date, callerId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}api_absensi_v2/pengguna_get_their_data_absen_hari/${callerId}/${date}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAttendanceStatistic = (startDate, endDate, callerId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${BaseUrlAttendanceProDev}api/v1/user/attendances/summary?callerId=${callerId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAttendanceProDetail = (
  size,
  page,
  startDate,
  endDate,
  callerId
) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${BaseUrlAttendanceProDev}api/v1/user/attendances/summary/account?startDate=${startDate}&endDate=${endDate}&callerId=${callerId}&page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAttendanceSpecialShift = (startDate, endDate, callerId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${BaseUrlAttendanceProDev}api/v1/user/attendances/special/summary?callerId=${callerId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAttendanceSpecialDetail = (
  size,
  page,
  startDate,
  endDate,
  callerId
) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${BaseUrlAttendanceProDev}api/v1/user/attendances/special?startDate=${startDate}&endDate=${endDate}&callerId=${callerId}&page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export function credentialCheck() {
  throw new Error("Function not implemented.");
}
